<template>
  <b-form inline class="ml-2">
    <b-form-text>Select beam</b-form-text>
    <b-form-select class="ml-2 mt-2" v-model="selected" v-bind:options="available_beams">
    </b-form-select>
  </b-form>
</template>

<script>
import axios from "axios";

export default {
  name: "BeamSelector",
  data() {
    return {
      selected : null,
      available_beams: []
    }
  },
  mounted() {
    axios.get('https://spaceweather.astron.nl/api/beams').then(response => {
      this.available_beams = ['all']
      this.available_beams = this.available_beams.concat(response.data)

    })
  },
  watch: {
    selected: function (val) {
      if(val === 'all') {
        this.$emit('select-beam', null);
      }else{
        this.$emit('select-beam', val);
      }

    }
  }
}
</script>

<style scoped>
</style>